module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/datagrid/datagrid.component.scss
// module id = ./libs/atenea-cms/src/datagrid/datagrid.component.scss
// module chunks = main